import React from 'react';
import Icon from '../../../components/AppIcon';

const QuoteFilters = ({ filters, setFilters }) => {
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Filter" size={20} className="text-gray-600" />
        <h3 className="text-sm font-medium text-gray-700">Filtres avancés</h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Statut</label>
          <select
            value={filters?.status}
            onChange={(e) => handleFilterChange('status', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <option value="all">Tous les statuts</option>
            <option value="pending">En attente</option>
            <option value="confirmed">Confirmé</option>
            <option value="expired">Expiré</option>
          </select>
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Période</label>
          <select
            value={filters?.dateRange}
            onChange={(e) => handleFilterChange('dateRange', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <option value="all">Toutes les dates</option>
            <option value="today">Aujourd'hui</option>
            <option value="week">Cette semaine</option>
            <option value="month">Ce mois</option>
            <option value="quarter">Ce trimestre</option>
          </select>
        </div>

        {/* Shipping Type Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Type d'envoi</label>
          <select
            value={filters?.shippingType}
            onChange={(e) => handleFilterChange('shippingType', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <option value="all">Tous les types</option>
            <option value="Envoi au volume (m³)">Envoi au volume</option>
            <option value="Barriques en quantité">Barriques</option>
            <option value="Conteneur 20 pieds">Conteneur 20'</option>
            <option value="Conteneur 40 pieds">Conteneur 40'</option>
          </select>
        </div>

        {/* Client Type Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Type de client</label>
          <select
            value={filters?.clientType}
            onChange={(e) => handleFilterChange('clientType', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            <option value="all">Tous les clients</option>
            <option value="Commerçant / Importateur">Commerçant</option>
            <option value="Association / ONG">Association</option>
            <option value="Entreprise / Envois réguliers">Entreprise</option>
            <option value="Déménagement complet">Déménagement</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default QuoteFilters;